'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import UITruncateString from 'UIComponents/text/UITruncateString';
import withConnectedTabLabel from 'DesignManagerIde/components/shared/hoc/withConnectedTabLabel';

class AllTabsMenuButton extends Component {
  render() {
    const {
      tab,
      label,
      openTab
    } = this.props;
    return /*#__PURE__*/_jsx(UIButton, {
      className: "p-y-0 tab-menu-options",
      use: "unstyled",
      onClick: openTab,
      children: /*#__PURE__*/_jsx(UITruncateString, {
        tooltip: false,
        children: label
      })
    }, tab.id);
  }

}

AllTabsMenuButton.propTypes = {
  tab: PropTypes.object.isRequired,
  openTab: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
};
export default withConnectedTabLabel(AllTabsMenuButton);